export default "__VITE_ASSET__BFuGM2e1__"